module.exports = __webpack_public_path__ + "img/sustainable_energy_color.86706697.svg";